<template>
    <section v-if="groupId" class="quick-cart-container" :data-qa="elementId" :id="elementId">
        <i v-if="multiCartMode" class="toggle-icon prz-close" @click="toggleProduct"/>
        <div v-if="!wsFailure && productInfo" class="prod-info-container" :class="{'m-0' : noOptions, 'cursor-pointer': isComboLinksActive}">
            <img @click="productUrlClick(productInfo.url)" :src="horizontalProdImage && productInfo.image_rect ? productInfo.image_rect.image_rect : productInfo.image" :alt="productInfo.name">
            <div class="prod-title" @click="productUrlClick(productInfo.url)">
                {{ productInfo.name }}
                <p v-if="!multiCartMode" class="prod-qty"> {{ comboKStrings.kQUANTITY + ': 01' }} </p>
                <br/>
                <div class="climatized" v-if="!multiCartMode && productIsFrozen">
                    <i class="prz-frozen"/>
                    <span v-if="comboKStrings"> {{ comboKStrings.kPRODUTO_CONGELADO }} </span>
                </div>
                <div v-if="multiCartMode && (responseComplete && priceData.total)" class="col-auto p-0 price-multi-container">
                    <!--                <span class="price-desc"> {{ kStrings.kGLOB_PRICE + ':' }} </span>-->
                    <div class="price-row">
                        <p v-if="productIsFrozen" class="frozen-description"> <i class="ecom-ice" /> {{ kStrings.kPRODUTO_CONGELADO }} </p>
                        <div v-if="bestPriceCoupon" class="campaign-price-info">
                            <Popper trigger="clickToToggle" position="bottom">
                                <i class="ecom-info" slot="activator"/>
                                <CampaignDetails :campaign="bestPriceCoupon" :kStrings="kStrings"/>
                            </Popper>
                        </div>
                        <p v-if="priceData.totalCrossed" class="price crossed"> {{ priceData.totalCrossed }} </p>
                        <p class="price"> {{ priceData.total }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!wsFailure && cartIsReady" class="add-cart-section" :class="{ 'no-options-cart': noOptions, 'empty-widget-warning' : selectedProduct && selectedProduct.warningDescription }">
            <ProductOptions
                v-if="wsProductData && selectionData"
                v-model="selectedProduct"
                :combo-cart-mode="true"
                :multi-cart-mode="multiCartMode"
                :use-thumb-radios="horizontalProdImage"
                :data="selectionData"
                :single-option="noOptions"
                :show-quantity="!comboCartMode && !multiCartMode"
                :empty-selection-warning="selectedProduct && selectedProduct.warningDescription"
                :out-of-stock="false"
                :can-add-to-cart="true"
                :lock-buttons="false"
                :is-pack="false"
                :item-id="groupId"
                :ref="selectionWidgetId"
                @has-carousel="hasCarousel"
            />
        </div>
        <div v-if="responseComplete && wsFailure && kStrings" class="quick-cart-unavailable m-0">
            <i class="ecom-error"/>
            <span class="warning-text col pr-0"> {{ kStrings.kSOMETHING_WRONG }}</span>
        </div>
<!--        <MuffinLoader v-if="!wsProductData"/>-->
    </section>
</template>

<script>
import {storeCombos} from '@/store/comboCart';

import ProductOptions from '@/components/ComboCart/widgets/ProductOptions.vue';
import MuffinLoader from '@/components/Muffin/Loader';
import Popper from '@/components/Muffin/Popper.vue';
import CampaignDetails from '@/components/ProductPage/CampaignDetails';
import apiCombos from '@/api/combos';
import websiteEvents from '@/Utilities/website-events';

export default {
    storeCombos,
    name: 'QuickCart',
    components: {
        ProductOptions,
        MuffinLoader,
        CampaignDetails,
        Popper
    },
    props: {
        comboId: {type: String, default: null},
        groupId: {type: String, default: null},
        comboCartMode: {type: Boolean, default: false},
        detailedInfo: {type: Boolean, default: false}, //TODO LATER FOR SPECIAL BANNERS
        webEventValue: {type: String, default: ''},
        preLoadedProductData: {type: Object, default: null},
        multiCartMode: {type: Boolean, default: false},
        horizontalProdImage: {type: Boolean, default: false},
    },
    data() {
        return {
            wsProductData: null,
            selectedProduct: null,
            responseComplete: false,
            priceData: {
                total: null,
                totalCrossed: null
            }
        }
    },
    computed: {
        kStrings(){
            return storeCombos.getters.kStrings;
        },
        elementId() {
            return this.groupId ? 'comboItem-' + this.groupId : 'comboItem';
        },
        selectionWidgetId() {
            return this.groupId ? 'selectionWidget-' + this.groupId : 'selectionWidget';
        },
        productStatus() { 
            return this.wsProductData ? this.wsProductData.productInfo.groupStatus : null;
        },
        productType() {
            return this.wsProductData ? this.wsProductData.productType : null;
        },
        productIsFrozen() {
            return this.wsProductData ? this.wsProductData.isFrozen : null;
        },
        comboKStrings() {
            return storeCombos.getters.comboKStrings;
        },
        productInfo() {
            if(!this.wsProductData){
                return null;
            }

            let img = null;
            if(this.selectedProduct){
                img = this.getNwImage(this.selectedProduct.images);
            }

            return {
                image: img ? img : this.wsProductData.productInfo.image,
                image_rect: this.selectedProduct ? this.getFHImage(this.selectedProduct.images) : null,
                name: this.selectedProduct ? this.selectedProduct.variantInfoData.name : this.wsProductData.productInfo.name,
                url: this.selectedProduct ? this.selectedProduct.variantInfoData.url : this.wsProductData.productInfo.url
            };
            
        },
        cartIsReady() {
            return this.wsProductData && this.productStatus == 'AC';
        },
        //widget data
        selectionData() {
            let data = null;
            if(this.wsProductData) {
                const wsData = this.wsProductData;
                // check if it has components 
                if (wsData.productComponentDefault && wsData.productComponentDefault.length > 0) {
                    data = {
                        productsList: wsData.products,
                        optionTypes: wsData.optionTypes,
                        fieldKeys: wsData.fieldKeys,
                        componentOrder: wsData.productComponentDefault,
                        singleOption: wsData.productComponentDefault.length > 1 ? false : true,
                    };
                    if(wsData.products.length == 1){
                        // product has components but only one product, set product as the selected one 
                        this.selectedProduct = wsData.products[0];
                    }
                } else {
                    this.selectedProduct = wsData.products[0];
                }
            }
            // no packs
            return data;
        },
        
        noOptions() {
            return (this.wsProductData && this.wsProductData.productComponentDefault.length == 0) || this.selectionData.singleOption;
        },
        
        wsFailure() {
            return (this.wsProductData && this.wsProductData.hasError) || !this.wsProductData;
        },

        isComboLinksActive() {
            return this.wsProductData && this.wsProductData.isComboLinksActive;
        },
        bestPriceCoupon(){
            const couponId = this.wsProductData.productInfo.bestPriceCoupon;
            if(couponId){
                const bestPriceCouponsData = this.wsProductData.bestPriceCoupons;
                const bestCoupon = bestPriceCouponsData && bestPriceCouponsData.find(coupon => coupon.couponId === couponId && coupon.groupId === this.selectedProduct.groupId);
                if(bestCoupon && bestCoupon.labelHtml) {
                    return bestCoupon;
                }
            }
            return null;
        },
        // isBlackRabbit() {
        //     return storeCombos.getters.isBlackRabbit;
        // },
    },
    watch: {
        selectedProduct(value) {
            if (!this.multiCartMode && (value && value.sku)) { // humm, pk é algo me diz que o watch vai fazer estragos
                    storeCombos.dispatch('setSkuList', {[this.groupId]: value.sku});
                    //if(!this.noOptions) {
                    storeCombos.dispatch('updateProductsPrice', {
                            comboId: this.comboId,
                            groupId: this.groupId,
                            price: value.priceVal,
                            priceCrossed: value.priceCrossedVal,
                        },
                    );
                    //}
            }
            
            if(this.multiCartMode && (value && (value.sku || value.varSku))) {
                this.priceData.total = value.priceVal ? App.js.formatPrice(value.priceVal) : null;
                let priceCrossed = value.priceCrossedVal ? value.priceCrossedVal : value.partnerPriceVal;
                this.priceData.totalCrossed = priceCrossed ? App.js.formatPrice(priceCrossed) : null;
                let selectedSku = value.sku ? value.sku : value.varSku;
                if(value.emptyWidget) {
                    selectedSku = null;
                }
                
                let data = {
                    groupId: this.groupId,
                    selectedSku: selectedSku,
                    stock: value.stock,
                    price: value.priceVal,
                    priceCrossed: value.priceCrossedVal ? value.priceCrossedVal : value.partnerPriceVal,
                    warningDescription: value.warningDescription
                }
                
                // for test only !!!
                /*if(data.groupId == '174278') {
                    data.price = 31.49;
                    data.priceCrossed = 44.99;
                }*/
                
                // **** //
                
                this.$emit('update-product', data);
            }
        },
        wsProductData(value) {
            if(value) {
                this.$emit('ws-ok');
            }
        }
    },
    // beforeCreate() {
    // },
    mounted() {
        this.$nextTick(function() {
            this.loadProductData();
        });
    },
    methods: {
        async loadProductData() {
            this.wsProductData = !this.preLoadedProductData ? await apiCombos.loadProdInfo(this.groupId) : this.preLoadedProductData;
            //console.log(this.groupId + ':', this.wsProductData);
            if(this.wsProductData) {
                this.setupStore(this.wsProductData);
            }
            this.responseComplete = true;
            this.$emit('loadComplete');
            //if(this.multiCartMode) {
               /* let data = {
                    groupId: this.groupId,
                    selectedSku: value.sku,
                    price: value.priceVal,
                    priceCrossed: value.priceCrossedVal,
                }
                this.$emit('update-product', data);*/
            //}
        },
        setupStore(data) {
            if(data) {
                //subject to change, kStrings must be from another model
                //storeCombos.dispatch('addProduct', this.wsProductData);
                storeCombos.dispatch('setKStrings', data.kStrings);
            }
        },
        getNwImage(imageData) { // can be discarded if BE returns in variant info data
            let nwImg = null;
            if(imageData) {
                nwImg = imageData.find(img=> img.imageStatus == 'NW');
            }
            
            return nwImg ? nwImg.image : null;
        },
        getFHImage(imageData) { // can be discarded if BE returns in variant info data
            let fhImg = null;
            if(imageData) {
                fhImg = imageData.find(img=> img.imageStatus == 'FH');
            }

            return fhImg ?? null;
        },
        hasCarousel() { // maybe redo for all types?   
            this.$emit('has-carousel');     
        },
        productUrlClick(url) {
            if(this.wsProductData && this.wsProductData.isComboLinksActive) {
                websiteEvents.eventCombo('click', this.webEventValue, {groupId: this.groupId});
                window.location.href = url;
            }
        },
        toggleProduct() {
            //if (this.selectedProduct) {
                this.$emit('toggle-product', this.groupId);
            //}
        }
            
    }
};
</script>

<style lang="scss" scoped>

</style>
